// extracted by mini-css-extract-plugin
var _1 = "styles-module__fallbackContainer___MtTxG";
export { _1 as "fallbackContainer" }
